import { useContext, useState, useMemo, useEffect } from "react";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import { filterUniqueDomains } from "./Sources";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";
import ReTableView from "../../Dashboard/common/ReTableView"
import { transformSourcesResponse, transformOldSourcesResponse } from "../../../utils/helpers"
import { downloadExcelV2, prepareSourceDataForExcel } from "../../../utils/monitoring-helpers";
import { Button } from "@mui/material";
import MUIMultiSelect from "../../../Component/UI/MUIMultiSelect/MUIMultiSelect";
import { OVERVIEW_LLM_LABELS } from "../../../utils/constant"
import classes from "./Sources.module.css";
import { ENTITY_LABELS } from "../../../utils/labelMapping";

const SourcesOverview = ({ category, isCategoryOverview = false }) => {
  const discoveryCtx = useContext(DiscoveryContext);
  const [llm, setLLM] = useState(discoveryCtx.llm);
  const [selectedBrandSources, setSelectedBrandSources] = useState(
    []);
  const discoveryType = discoveryCtx.type || "brand";
  const selectedCategory = isCategoryOverview ? category : discoveryCtx.state.selectedCategory;
  const selectedLLM = isCategoryOverview ? [discoveryCtx.state.selectedLLM] : llm;
  const selectedMarket = discoveryCtx.state.selectedMarket;
  const selectedPersona = discoveryCtx.state.selectedPersona;
  const sources = discoveryCtx?.sources ?? [];
  const showOldSourcesRecord = discoveryCtx.state.sourceValidationStatus === "PENDING";
  const sourcesData = {};
  const allMetricsKeys = selectedLLM.reduce((acc, currentLLM) => {
    const llmSources = sources?.[currentLLM]?.[selectedCategory]?.[selectedMarket]?.[selectedPersona] || {};
    Object.keys(llmSources).forEach(key => {
      if (!acc.includes(key)) acc.push(key);
    });
    return acc;
  }, []);

  const dropdownOptions = allMetricsKeys.map(key => ({ value: key, label: key }));

  useEffect(() => {
    setSelectedBrandSources(dropdownOptions.map((o) => o.value));
  }, [JSON.stringify(dropdownOptions)]);


selectedLLM.forEach(currentLLM => {
  if (!sourcesData[currentLLM]) sourcesData[currentLLM] = {};
  if (!sourcesData[currentLLM][selectedCategory]) sourcesData[currentLLM][selectedCategory] = {};
  if (!sourcesData[currentLLM][selectedCategory][selectedMarket]) sourcesData[currentLLM][selectedCategory][selectedMarket] = {};

  const llmSources = sources?.[currentLLM]?.[selectedCategory]?.[selectedMarket]?.[selectedPersona] || {};

  if (showOldSourcesRecord) {
    sourcesData[currentLLM][selectedCategory][selectedMarket][selectedPersona] = selectedBrandSources.reduce((acc, key) => {
      if (llmSources[key]) {
        const sourceObj = llmSources[key];
        Object.keys(sourceObj).forEach(url => {
          if (acc[url]) {
            acc[url] += sourceObj[url];
          } else {
            acc[url] = sourceObj[url];
          }
        });
      }
      return acc;
    }, {});
  } else {
    sourcesData[currentLLM][selectedCategory][selectedMarket][selectedPersona] = selectedBrandSources.reduce((acc, key) => {
      if (llmSources[key]) {
        acc.push(...(Array.isArray(llmSources[key]) ? llmSources[key] : [llmSources[key]]));
      }
      return acc;
    }, []);
  }
});

  const selectedInput = {
    brand: discoveryCtx.entity,
    category: selectedCategory,
    // geography: selectedMarket,
    llm: discoveryCtx.state.selectedLLM,
    market: selectedMarket,
    persona: selectedPersona,
    product: discoveryCtx.type == "product" ? true : false,
  }
  const labelMapping = {
    LLM: "llm",
  }
  const sourceFilter = {
    value: "LLM",
    label: "Compare by LLM"
  }

  useEffect(() => {
    setLLM(discoveryCtx.llm)
  }, [discoveryCtx.llm])


  const data = useMemo(() => {
    if (showOldSourcesRecord) {
      return transformOldSourcesResponse(sourcesData, selectedLLM, selectedCategory, selectedMarket, selectedPersona);
    } else {
      return transformSourcesResponse(sourcesData, selectedLLM, selectedCategory, selectedMarket, selectedPersona);

    }
  }, [sourcesData, selectedLLM, selectedCategory, selectedMarket, selectedPersona]);
  const id = "Sources_Overview";
  const uniqueKey = `${tab.brandOverview}_${id}_${discoveryCtx?.state?.selectedCategory}_${discoveryCtx?.state?.selectedMarket}_${discoveryCtx?.state?.selectedPersona}`
  const { checked } = useIsSelectedSection({ id, tab: tab.brandOverview, uniqueKey });
  const isFinalAudit = discoveryCtx?.state?.finalTransactionId === discoveryCtx?.state?.transactionId
  const isSourceValidating =
    discoveryCtx.state?.sourceValidationStatus === "RUNNING" &&
    ["COMPLETED", "RETRY"].includes(discoveryCtx.state?.transactionStatus) && isFinalAudit;

  return (
    <>
      <br />
      {!isCategoryOverview && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <h5 style={{ marginRight: "8px" }}>Sources Overview</h5>
              {discoveryCtx.state.showReportCheckbox && (
                <Checkbox
                  checked={checked}
                  onChange={() => {
                    discoveryCtx?.clickComponentCheckbox({
                      uniqueKey,
                      filter: {
                        id: id,
                        title: "Sources Overview",
                        tab: tab.brandOverview,
                        uniqueKey,
                        llm: null,
                      },
                      checked,
                      id,
                    });
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              )}
            </div>

            <div>
              <MUIMultiSelect
                // label={"LLM"}
                allowSettingPrimary={false}
                options={discoveryCtx.llm.map((item) => ({
                  value: item,
                  name: OVERVIEW_LLM_LABELS[item],
                }) ?? [])}
                value={llm || ["gpt-4o"]}
                renderSelectedValues={(selected) => {
                  return selected
                    .map(val => OVERVIEW_LLM_LABELS[val] || "gpt-4o")
                    .join(", ");
                }}
                onChange={(selected) => {
                  setLLM(selected);
                }}
              />
            </div>
          </div>

          <hr />
        </>
      )}
      <Button
        onClick={() => {
          const preparedData = prepareSourceDataForExcel(data, selectedInput, labelMapping, sourceFilter);
          downloadExcelV2(preparedData, labelMapping[sourceFilter?.value]);
        }}
      >
        Export
      </Button>
      {isSourceValidating &&
        <div className={classes.validationMessage}>
          <div>
            <span style={{ fontSize: "18px", marginRight: "8px" }}>⏳</span>
            Source validation is still in progress
          </div>
        </div>
      }
      <div id={id}>
        <ReTableView
          type={`${discoveryType === "brand" ? ENTITY_LABELS.brand : ENTITY_LABELS.product}`}
          data={data}
          isValidated={!showOldSourcesRecord}
          isOverview={true}
          dropdownOptions={dropdownOptions}
          selectedDropdownValues={selectedBrandSources}
          onDropdownChange={(newVal) =>
            setSelectedBrandSources(Array.isArray(newVal) ? newVal : (newVal?.target ? newVal.target.value : selectedBrandSources))
          } />
      </div>
    </>
  );
};

export default SourcesOverview;

export function formatDomainData(mapArr, data, filterArr, market, mode = "count") {
  let formatted = {};

  mapArr.forEach((key) => {
    if (!data[key]) return;
    let propertyArr = Object.entries(data[key]);
    if (!propertyArr.length) return;

    propertyArr.forEach(([name, obj]) => {
      if (!filterArr.includes(name)) return;

      let marketUrls = obj?.[market] || [];

      let domains = filterUniqueDomains(marketUrls);

      let reduceObj = domains.reduce((acc, d) => {
        if (mode === "count") {
          acc[d.src] = d?.urls?.length ?? 0;
        } else if (mode === "urls") {
          acc[d.src] = (d?.urls ?? []).map((url) => ({
            url,
            http_status: "200", // hardcoded
          }));
        }
        return acc;
      }, {});

      if (mode === "count") {
        // keep LLM key wrapper
        formatted[key] = { ...formatted[key], ...reduceObj };
      } else {
        // flatten (no LLM key)
        formatted = { ...formatted, ...reduceObj };
      }
    });
  });

  return formatted;
}

export function extractDomain(mapArr, data, filterArr, market, mode = "count") {
  let formatted = {};

  mapArr.forEach((llmKey) => {
    if (!data[llmKey]) return;

    let propertyArr = Object.entries(data[llmKey]);
    if (!propertyArr.length) return;

    propertyArr.forEach(([categoryName, obj]) => {
      if (!filterArr.includes(categoryName)) return;

      let marketUrls = obj?.[market] || [];
      let domains = filterUniqueDomains(marketUrls);

      domains.forEach((d) => {
        const domain = d.src;

        if (mode === "count") {
          if (!formatted[domain]) {
            formatted[domain] = { name: domain };
          }
          formatted[domain][llmKey] = d.urls.length;
        } else if (mode === "urls") {
          if (!formatted[domain]) {
            formatted[domain] = [];
          }
          // add urls with LLM info
          const urls = (d?.urls ?? []).map((url) => ({
            url,
            http_status: "200",
            llm: llmKey
          }));
          formatted[domain].push(...urls);
        }
      });
    });
  });

  if (mode === "count") {
    // ensure all LLM keys exist in each object
    return Object.values(formatted).map((entry) => {
      mapArr.forEach((llmKey) => {
        if (!(llmKey in entry)) {
          entry[llmKey] = 0;
        }
      });
      return entry;
    });
  } else {
    // mode = "urls", return dictionary domain -> urls[]
    return formatted;
  }
}


